var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTextHighlightColor = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 61c-1.104 0-2-0.896-2-2l0.020-24.832c0.052-3.372 0.096-6.28-1.052-7.444-0.576-0.584-1.596-0.864-3.124-0.864-2.496 0-3.876 1.108-4.3 2.064-0.448 1.008-1.628 1.464-2.644 1.008-1.008-0.448-1.46-1.632-1.008-2.644 1.22-2.732 4.268-4.428 7.952-4.428 2.656 0 4.608 0.672 5.972 2.060 2.324 2.356 2.268 6.044 2.204 10.308l-0.020 2.236v22.54c0 1.1-0.896 1.996-2 1.996z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 63.032c-3.944 0-13.176 0-13.176-10.008 0-7.784 6.836-18.564 19.676-18.564 1.104 0 2 0.896 2 2v24.54c0 1.104-0.896 2-2 2l-6.5 0.032zM28 38.568c-9.636 1.060-13.676 9.696-13.676 14.456 0 4.548 2.232 6.008 9.176 6.008l4.5-0.032v-20.432z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61c-1.104 0-2-0.896-2-2v-44c0-1.104 0.896-2 2-2s2 0.896 2 2v44c0 1.104-0.896 2-2 2z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.228 63.032v0l-9.228-0.032c-1.104 0-2-0.9-2-2v-24.54c0-1.104 0.896-2 2-2 13.076 0 21.1 10.812 21.1 18.564 0 4.056-1.36 6.912-4.040 8.488-2.272 1.332-5.104 1.52-7.832 1.52zM40 59l7.228 0.032c2.16 0 4.356-0.116 5.808-0.968 0.888-0.524 2.068-1.612 2.068-5.040 0-4.772-5.176-13.42-15.1-14.46l-0.004 20.436z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.636 97.816c-0.516 0-1.028-0.2-1.416-0.584-0.616-0.616-0.764-1.568-0.36-2.336l10.244-19.648c0.088-0.18 0.216-0.344 0.36-0.484l38.856-38.852c0.376-0.376 0.884-0.584 1.416-0.584v0c0.532 0 1.040 0.212 1.416 0.584l9.4 9.408c0.78 0.78 0.78 2.048 0 2.828l-38.852 38.848c-0.14 0.144-0.304 0.26-0.492 0.36l-19.644 10.24c-0.296 0.148-0.612 0.22-0.928 0.22zM55.504 77.368l-7.16 13.736 13.736-7.164 37.228-37.216-6.572-6.58-37.232 37.224z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.548 48.14l-2.832-2.828 5.972-5.98c1.288-1.28 2.096-2.852 2.288-4.424 0.168-1.392-0.188-2.608-1-3.42-1.784-1.78-5.384-1.196-7.852 1.276l-5.972 5.972-2.828-2.828 5.972-5.972c4.072-4.072 10.124-4.648 13.508-1.276 1.7 1.704 2.46 4.092 2.14 6.728-0.292 2.46-1.508 4.868-3.424 6.78l-5.972 5.972z",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.354 82.996l-9.413-9.407 2.828-2.829 9.413 9.407-2.828 2.829z",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116 107h-112c-1.104 0-2-0.9-2-2s0.896-2 2-2h112c1.1 0 2 0.9 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTextHighlightColor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Text-HighlightColor.8346eb89.svg";
export { ForwardRef as ReactComponent };